<template>
  <div style="width: 100%">
    <v-row align="center" no-gutters>
      <div class="title text--secondary my-2 px-4 text-uppercase">
        {{ $t("profile.mentorship.feedback.title") }}
      </div>
      <v-spacer></v-spacer>
      <v-btn
        small
        class="primary accent-4 white--text mr-2"
        @click="print('printFeedbackFromSection', name)"
      >
        <v-icon small left>print</v-icon>
        {{ $t("profile.history.print") }}
      </v-btn>
    </v-row>
    <div v-if="$apollo.loading" class="title">loading...</div>
    <v-card v-if="html" id="printFeedbackFromSection">
      <div v-html="html" class="pa-4" />
    </v-card>
  </div>
</template>

<script>
import MentorshipFeedbackAssignedHTMLQuery from "@/graphql/queries/mentorship/feedback/MentorshipFeedbackAssignedHTML.gql";
import MentorshipFeedbackHTMLQuery from "@/graphql/queries/mentorship/feedback/MentorshipFeedbackHTML.gql";

import { print } from "@/utils/print";

export default {
  props: {
    isAssigned: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    language() {
      return this.$route.query.language || this.$i18n.locale;
    },
  },
  methods: {
    print: print,
  },
  apollo: {
    html: {
      query() {
        return this.isAssigned
          ? MentorshipFeedbackAssignedHTMLQuery
          : MentorshipFeedbackHTMLQuery;
      },
      variables() {
        return {
          id: this.$route.params.id,
          language: this.language,
        };
      },
      skip() {
        return !this.$route.params.id;
      },
    },
  },
};
</script>
